var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        clearable: "",
        filterable: "",
        placeholder: "Sélection",
        size: "mini"
      },
      on: {
        change: function($event) {
          return _vm.onChange($event)
        },
        clear: function($event) {
          return _vm.onClear()
        }
      },
      model: {
        value: _vm.idTypeVente,
        callback: function($$v) {
          _vm.idTypeVente = $$v
        },
        expression: "idTypeVente"
      }
    },
    _vm._l(_vm.typeVenteList, function(item) {
      return _c(
        "el-option",
        {
          key: item.id,
          attrs: { label: item.libelle, value: item.id, disabled: !item.actif }
        },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v(_vm._s(item.libelle))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                float: "right",
                color: "#8492a6",
                "font-size": "13px",
                "font-style": "italic"
              }
            },
            [_vm._v(" " + _vm._s(item.code))]
          )
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }